import {colorSwatch} from '../utils/colorSwatch.js';
import {MenuPanels} from '../../models/UIModel.js';
import {MenuButton} from '../components/menu-button.js';
import {ShoppeBase} from './shoppe-base.js';
import {goToMainMenu} from '../utils/gotoMainMenu.js';
import {Column} from '@wonderlandengine/react-ui/components';
import {Align, Justify} from '@wonderlandengine/react-ui';
import {goToMenu} from '../utils/goToMenu.js';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {Localization} from '../../utils/Localization.js';

export const ShoppeMenu = () => {
    return (
        <ShoppeBase
            title={Localization.instance.get('Shoppe')}
            onOkay={() => goToMainMenu()}
        >
            <Column
                paddingBottom={100}
                justifyContent={Justify.SpaceEvenly}
                alignItems={Align.Center}
                flexGrow={1}
            >
                <MenuButton
                    height={80}
                    width={400}
                    onClick={() => goToMenu(MenuPanels.StorePowerups)}
                    color={colorSwatch.ShoppePowerups}
                    icon={UiTexturesManager.instance.iconInventory}
                    iconHeight={60}
                    iconWidth={60}
                >
                    {Localization.instance.get('Powerups')}
                </MenuButton>
                <MenuButton
                    width={400}
                    height={80}
                    onClick={() => goToMenu(MenuPanels.StorePerks)}
                    color={colorSwatch.ShoppePerks}
                    icon={UiTexturesManager.instance.iconPerk}
                    iconHeight={60}
                    iconWidth={60}
                >
                    {Localization.instance.get('Perks')}
                </MenuButton>
                <MenuButton
                    height={80}
                    width={400}
                    onClick={() => goToMenu(MenuPanels.Malwear)}
                    color={colorSwatch.ShoppeMalwear}
                    icon={UiTexturesManager.instance.iconMalware}
                    iconHeight={60}
                    iconWidth={60}
                >
                    {Localization.instance.get('MalwearTitle')}
                </MenuButton>
                <MenuButton
                    height={80}
                    width={400}
                    fontSize={24}
                    onClick={() => goToMenu(MenuPanels.StoreSpecialOffers)}
                    color={colorSwatch.ShoppeSpecialOffers}
                    icon={UiTexturesManager.instance.offers}
                    iconHeight={60}
                    iconWidth={60}
                >
                    {Localization.instance.get('SpecialOffersTitle')}
                </MenuButton>
            </Column>
        </ShoppeBase>
    );
};
